import { render, staticRenderFns } from "./FilterSelect.vue?vue&type=template&id=2d4e9283&"
import script from "./FilterSelect.vue?vue&type=script&lang=js&"
export * from "./FilterSelect.vue?vue&type=script&lang=js&"
import style0 from "./FilterSelect.vue?vue&type=style&index=0&id=2d4e9283&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
